<template>
<v-container class="pa-5">
      <v-row>
      <v-col cols="6" class="mt-4 text-right ">
         <img :src="$store.state.main_arrow" width="460px"/>
         <p style="margin-top: -100px">
           <span class="xlg-font text-gray">SILICA</span> <br />  <span class="text-primary lg-font-s"> Returnable Glass Bottle System </span>  
         </p>
           <!-- Securing peace of mind. -->
         
      </v-col>
      <v-col cols="6" >
          <v-form  
                
                  ref="form"
                  v-model="valid"
                  lazy-validation
                  style="width: 400px;"
                >
              <v-card style="margin-top: 15%; background: #FAFAFA;" class="pa-2" flat>
                <p class="text-center pt-5">
                  <img :src="$store.state.systemlogo" width="100px"/>
                </p>
                <v-card-text>
                      
                        <v-text-field
                          v-model="username"
                          :rules="nameRules"
                          label="Username"
                          append-icon="mdi-account"
                          required
                          dense
                          outlined
                        ></v-text-field>
                    
                        <v-text-field
                          v-model="password"
                          :rules="passRules"
                            append-icon="mdi-key"
                          dense
                          label="Password"
                          type="password"
                          v-on:keyup.enter="validate()"
                          required
                          outlined
                        ></v-text-field>
                        <v-icon>mdi-checkbox</v-icon>
                 
                    <v-card-actions class="md-font pa-0"> 
                          <v-checkbox input-value="true" dense value></v-checkbox>Keep me signed in
                          <v-spacer/>
                          <!-- <a href="/forgot-password"> I can't login?</a> -->
                    </v-card-actions>
                </v-card-text>
                <v-card-actions class="pt-1 pb-5">
                    <v-btn
                          color="primary"
                          block
                          rounded
                          large
                          :loading="loading"
                          @click="validate()"
                        >
                          LOGIN
                          <v-icon right>mdi-key</v-icon>
                        </v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
      </v-col>
   </v-row>
</v-container>
</template>
<script>
 import md5 from 'md5'
import {
  mapMutations
} from 'vuex'
  export default {
    data: () => ({
      valid: true,
      loading: false,
      username: '',
      nameRules: [
        v => !!v || 'Username is required'
      ],
      passRules: [
        v => !!v || 'Password is required'
      ],
      password: '',
      snackbar: false,
    }),
    created() {
      if (this.$session.exists()) {
          this.setLoggedIn(false)
          this.$session.destroy()
      }
         
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn', 'setDrawer']),
      
      validate () {
      if (this.$refs.form.validate()) {
        this.loading=true
         this.login()
       }
      },
      login(){
         var param = {
            Username: this.username,
            Password: md5(this.password)
          }
          this.$http.post("user/login",param).then(response => {
          if(response.data.status == true) {
            this.$session.start()
            this.$session.set('jwt', response.data.account.token)
            this.$session.set('username', response.data.account.username)
            this.$session.set('role', response.data.account.role)
            sessionStorage.allowed_pages = JSON.stringify(response.data.account.allowed_pages)
            this.$session.set('userID', response.data.account.id)
            this.VA_ALERT('success', response.data.message)
              this.SET_MENUS()
            setTimeout(()=>{this.$router.push('/dashboard')},700) 
            setTimeout(()=>{this.setLoggedIn(true)},1000) 
          } else {
            this.VA_ALERT('error', response.data.message)
          }
            this.loading = false
          }).catch(e => {
            this.loading = false
              this.NETWORK_ERROR(e)
         })
        
          
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
    },
  }
</script>
<style>
  
</style>